import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
// import { ReportesRepository } from 'src/app/reporte-ventas/domain/reportes.repository';
import { UtilService } from 'src/app/services/util.service';
import { newmetadate } from 'src/app/shared/components/datatable/domain/datatable-domain';
import { FormModule } from 'src/app/shared/modulos/form.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { ReporteCierreAnualRequest } from '../../../domain/request/comercial-reportes-request';
import { ReportesRepository } from 'src/app/repositorio/reportes.repository';

@Component({
    selector: 'app-reporte-cierre-anual',
    templateUrl: './reporte-cierre-anual.component.html',
    styleUrls: ['./reporte-cierre-anual.component.css'],
    standalone: true,
    imports: [
        CommonModule,
        FormModule,
        SharedModule
    ]
})
export class ReporteCierreAnualComponent {

  constructor(
    private readonly util: UtilService,
    private readonly servReporte: ReportesRepository
  ) { }

  group: FormGroup
  datatable: any[] = []
  anio01 = ""
  anio02 = ""
  metadatatable: newmetadate[] = [
    { field: 'entc_nomejecutivo', title: 'CNEE', inputType: 'text', style: { justify: 'left' } },
    { field: 'teus_01', title: 'Teus (' + this.anio01 + ')', inputType: 'int', rowFooter: "sum" },
    { field: 'teus_02', title: 'Teus (' + this.anio02 + ')', inputType: 'int', rowFooter: "sum" },
    { field: 'diferencia', title: 'Diferencia', inputType: 'int', rowFooter: "sum" },
  ]

  // getAnioMinMax(option: 'min' | 'max'): string {
  //   var anio = ""
  //   if (this.group.value.anios && this.group.value.anios.length === 2) {
  //     const fechas = this.group.value.anios
  //     if (option = "min") {
  //       anio = Math.min(...fechas).toString();
  //     } else {
  //       anio = Math.max(...fechas).toString();
  //     }
  //   }
  //   return anio
  // }

  cargarAnios() {
    if (this.group.value.anios && this.group.value.anios.length === 2) {
      const fechas = this.group.value.anios

      this.anio01 = Math.min(...fechas).toString();
      this.anio02 = Math.max(...fechas).toString();

      this.metadatatable.find(r => r.field === "teus_01").title = 'Teus (' + this.anio01 + ')'
      this.metadatatable.find(r => r.field === "teus_02").title = 'Teus (' + this.anio02 + ')'

    }
  }

  ngOnInitForm() {
    let anio = new Date().getFullYear()

    this.group = new FormGroup({
      anios: new FormControl([anio - 1, anio], [Validators.maxLength(2), Validators.minLength(2)])
    })

    const fechas = this.group.value.anios

    this.anio01 = Math.min(...fechas).toString();
    this.anio02 = Math.max(...fechas).toString();

    this.metadatatable.find(r => r.field === "teus_01").title = 'Teus (' + this.anio01 + ')'
    this.metadatatable.find(r => r.field === "teus_02").title = 'Teus (' + this.anio02 + ')'
  }

  anios: any[] = []
  ngOnInit(): void {
    this.anios = this.util.getAnios()
    this.ngOnInitForm()
  }

  search() {
    if (this.group.valid) {
      this.datatable = []
      const values = this.group.value
      console.log(values.anios)
      let request = <ReporteCierreAnualRequest>{}
      request.anios = values.anios.map(r => {
        return {
          filt_codigoint: r,
          filt_codigovar: '',
          filt_nombre: ''
        }
      })
      console.log(request)
      this.servReporte.ReporteCierreAnual(request).subscribe(response => {
        this.datatable = response.datos.result
      })
    }

  }
}
